import {
  hideSnackbar,
  SHOW_SNACKBAR,
  SHOW_STICKY_SNACKBAR,
  SHOW_ZIPCODE_SNACKBAR,
  HIDE_SNACKBAR
} from 'common/actions/snackbar'

// How long each kind of message stays on screen. SHOW_STICKY_SNACKBAR is not
// here on purpose: it stays until the user closes it, signs in again or
// reloads the page.
const DURATIONS = {
  [SHOW_SNACKBAR]: 4000,
  [SHOW_ZIPCODE_SNACKBAR]: 8000
}

const ENDS_TIMER = [SHOW_SNACKBAR, SHOW_STICKY_SNACKBAR, SHOW_ZIPCODE_SNACKBAR, HIDE_SNACKBAR]

export default () => dispatch => {
  // The timer of the message on screen. A new message stops the old timer, so
  // it cannot hide the new message early, such as the sticky one.
  let timer = null

  return action => {
    if (ENDS_TIMER.includes(action.type)) {
      clearTimeout(timer)
      timer = null
    }

    const duration = DURATIONS[action.type]

    if (duration !== undefined) {
      timer = setTimeout(() => {
        dispatch(hideSnackbar())
      }, duration)
    }

    dispatch(action)
  }
}
